<template>
  <div class="carbox_container">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <!-- 搜索栏 -->
    <van-search
      v-model="value"
      placeholder="搜索要找的联系人"
      show-action
      shape="round"
      @search="onSearch"
      left-icon="https://api.xianpipa.com/xianpipa/images/contacts_icon_search.png"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div style="padding-top:106px;">
      <!-- 名片列表 -->
      <div class="indexes" style="background-color:#f8f8f8;">
        <div v-for="(item,index) in cartslist" :key="index">
          <div
            v-if="item.letter"
            class="padding"
            :class="'indexItem-'+indexList[index]"
            :id="'indexes-'+indexList[index]"
            :ref="'indexes-'+indexList[index]"
            :data-index="indexList[index]"
          >{{item.letter}}</div>
          <div class="cu-list menu-avatar no-padding">
            <div v-for="(cell,index) in cartslist[index].list" :key="index">
              <div class="cu-item item-bottomline" :data-id="cell.id" @click="linktoCart">
                <div
                  v-if="cell.avatar_url"
                  class="cu-avatar round lg"
                  :style="'background-image:url('+cell.avatar_url+');'"
                ></div>
                 <div
                 v-else
                  class="cu-avatar round lg"
                  :style="'background-image:url('+guideIconSlider+');'"
                ></div>
                <div>
                  <div
                    class="text-grey texts-messages"
                    v-if="cell.name.length + cell.job_title.length<12"
                  >
                    <span class="texts-names">{{cell.name}}</span>
                    <span class="texts-job">{{cell.job_title}}</span>
                  </div>
                  <div class="text-grey texts-messages" v-else>
                    <div class="texts-names">{{cell.name}}</div>
                    <div class="text-sm texts-job">{{cell.job_title}}</div>
                  </div>
                  <div class="text-gray text-sm texts-company">{{cell.company_name}}</div>
                </div>
                <!-- 电话 -->
                <div class="communication">
                  <img
                    class="cu-avatar phone-icon"
                    :data-tel="cell.tel"
                    @click.stop="callMobile"
                    :src="phoneIcon"
                  />
                  <img
                    class="cu-avatar message-icon"
                    :data-id="cell.id"
                    :data-chatname="cell.name"
                    @click.stop="linktoMessage"
                    :src="messageIcon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nofollowbox" v-if="searchList.length == 0 && cartslist.length != 0">
        <div class="nofollowpic">
          <img :src="nofollowpicIcon" />
        </div>
        <div class="nosearchtext">暂无搜索信息</div>
      </div>
      <div class="nofollowbox" v-if="cartslist.length == 0">
        <div class="nofollowpic">
          <img :src="nofollowpicIcon" />
        </div>
        <div class="nosearchtext">暂无联系人</div>
      </div>
    </div>
    <!-- 右边边字母列表 -->
    <div class="indexBar" style="height:calc(100% - 100px - 50px)">
      <div class="indexBar-box" ref="indexBarBox">
        <div
          class
          @touchstart="tStart"
          @touchend="tEnd"
          @touchmove="tMove"
          v-for="(item,index) in indexList"
          :key="index"
        >
          <div class="indexBar-item" :id="index" @touchstart="getCur" @touchend="setCur">{{item}}</div>
        </div>
      </div>
    </div>
    <!--选择显示-->
    <div v-if="hidden" class="indexToast">{{listCur}}</div>
  </div>
</template>

<script>
import { getcartLlist } from "../../api/api";
import Vue from "vue";
import { IndexBar, IndexAnchor, Dialog } from "vant";

Vue.use(Dialog);
Vue.use(IndexBar).use(IndexAnchor);
import navbar from "../public/navbar.vue";
export default {
  name: "cartbox",
  components: { navbar },
  data() {
    return {
      hidden: false,
      value: "",
      titlename: "搜索",
      indexList: [],
      cartslist: [],
      list: [],
      vantop: 102,
      searchList: [],
      page: 0,
      pageCount: 0,
      listCur: "A",
      phoneIcon: require("../../assets/images/contacts_icon_call.png"),
      messageIcon: require("../../assets/images/contacts_icon_contact.png"),
      nofollowpicIcon: require("../../assets/images/circle_icon_wu.png"),
      guideIconSlider:require("../../assets/images/guide_icon_slider.png")
    };
  },
  created() {
    document.title="名片盒";
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "chat" || from.name == "othercart") {
      to.meta.keepAlive = true;
    }
    next();
  },
  methods: {
    //触发全部开始选择
    tStart() {
      this.hidden = true;
    },

    //触发结束选择
    tEnd() {
      this.hidden = false;
      var name = "indexes-" + this.listCur;
      var arr = this.$refs;
      var indexes = arr[name][0];
      //滑动div
      var offsetHeight = indexes.offsetTop;
      window.scrollTo({
        top: offsetHeight,
        behavior: "smooth"
      });
    },
    //滑动选择Item
    tMove(e) {
      let y = e.touches[0].clientY,
        offsettop = this.$refs.indexBarBox.offsetHeight,
        that = this;
      //判断选择区域,只有在选择区才会生效
      if (y > offsettop) {
        let num = parseInt((y - offsettop) / 20);
        this.listCur = that.indexList[num];
      }
    },
    //获取文字信息
    getCur(e) {
      this.hidden = true;
      this.listCur = this.indexList[e.target.id];
    },

    setCur(e) {
      this.hidden = false;
      this.listCur = this.listCur;
    },
    //获取名片列表
    initCartList() {
      let json = {
        page: 0,
        keyword: ""
      };
      getcartLlist(json).then(res => {
        let list = [];
        if (res.data.code == 200) {
          this.pageCount = res.data.data.pageCount;
         Object.keys(res.data.data.list).forEach(function(key){
          list.push(res.data.data.list[key].letter)
        });
          this.indexList = list;
          this.cartslist = res.data.data.list;
          if (this.cartslist[0].list) {
            this.searchList = this.cartslist[0].list;
          }
        }
      });
    },
    onSearch: function() {
      var inputvalue = this.value;
      if (inputvalue == "") {
        this.cartslist = []
        return;
      }
      let json = {
        page: 0,
        keyword: inputvalue
      };

      getcartLlist(json).then(res => {
        let list = [];
        if (res.data.code == 200) {
          var cartslist = res.data.data.list;
          var cartboxlist = [];
          cartslist.map(function(value, index, array) {
            cartboxlist = cartboxlist.concat(value.list);
          });
          cartboxlist = cartboxlist.filter(
            val => val.name.indexOf(inputvalue) != -1
          );
          cartslist = [
            {
              letter: "",
              list: cartboxlist
            }
          ];
          this.cartslist = cartslist;
          this.searchList = cartslist[0].list;
        }
      });
    },
    linktoCart: function(e) {
      this.$router.push({
        name: "othercart",
        query: {
          id: e.currentTarget.dataset.id
        }
      });
    },
    callMobile: function(e) {
      let that = this;
      let tel = e.currentTarget.dataset.tel;
      Dialog.confirm({
        message: "拨打" + tel + "？"
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + tel;
        })
        .catch(() => {
          // on cancel
        });
    },
    linktoMessage: function(e) {
      this.$router.push({
        name: "chat",
        query: {
          id: e.currentTarget.dataset.id,
          chatname: e.currentTarget.dataset.chatname
        }
      });
    }
  }
};
</script>

<style scoped>
.navbar {
  position: relative;
  z-index: 99;
}
.carbox_container {
  height: 100%;
  background-color: #f8f8f8;
}
.top-lines {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1024;
  border-top: 0.02702702702702703rem solid #f8f8f8;
}
.item-bottomline {
  border-bottom: 0.02702702702702703rem solid #f8f8f8;
}
.item-bottomline:last-of-type {
  border: none;
}
.communication {
  display: flex;
  margin-right: 1.7027027027027026rem;
}
.phone-icon {
  width: 1.135135135135135rem;
  height: 1.135135135135135rem;
  margin-right: 1.054054054054054rem;
}
.message-icon {
  width: 1.1891891891891893rem;
  height: 1.135135135135135rem;
}
.searchs-btns {
  background-image: linear-gradient(-90deg, #f9da5b, #ffbd0a);
  color: #fff;
}
.texts-messages {
  font-size: 0.6486486486486487rem;
}
.texts-names {
  color: #000;
  margin-right: 0.6486486486486487rem;
  font-weight: bold;
  font-family: "SimHei";
  font-size: 0.8108108108108109rem;
  margin-bottom: 0.35135135135135137rem;
}
.texts-job {
  font-size: 0.7027027027027027rem;
  color: #666;
}
.texts-company {
  width: 10.81081081081081rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.7027027027027027rem;
  color: #999;
  margin-top: 0.2702702702702703rem;
}
.indexes {
  position: relative;
}
.indexBar {
  position: fixed;
  right: 0rem;
  bottom: 0rem;
  padding: 0.5405405405405406rem 0.5405405405405406rem 0.5405405405405406rem
    0.2702702702702703rem;
  display: flex;
  align-items: center;
}
.indexBar .indexBar-box {
  width: 1.0810810810810811rem;
  height: auto;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0.5405405405405406rem rgba(0, 0, 0, 0.1);
  border-radius: 0.2702702702702703rem;
}
.indexBar-item {
  flex: 1;
  width: 1.0810810810810811rem;
  height: 1.0810810810810811rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6486486486486487rem;
  color: #888;
}
movable-view.indexBar-item {
  width: 1.0810810810810811rem;
  height: 1.0810810810810811rem;
  z-index: 9;
  position: relative;
}
movable-view.indexBar-item::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0.2702702702702703rem;
  height: 0.5405405405405406rem;
  width: 0.10810810810810811rem;
  background-color: #f37b1d;
}
.indexToast {
  position: fixed;
  top: 0;
  right: 2.1621621621621623rem;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 2.7027027027027026rem;
  height: 2.7027027027027026rem;
  border-radius: 0.2702702702702703rem;
  margin: auto;
  color: #fff;
  line-height: 2.7027027027027026rem;
  text-align: center;
  font-size: 1.2972972972972974rem;
}
.nofollowbox {
  padding-top: 2.7027027027027026rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.search-icon {
  font-size: 0.7837837837837838rem;
  font-weight: bold;
  color: #a4a4a4;
}
.cu-list.menu-avatar .cu-item {
  position: relative;
  display: flex;
  padding-right: 0.2702702702702703rem;
  height: 3.7837837837837838rem;
  background-color: white;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
}
.cu-avatar.lg {
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
  font-size: 2em;
  border-radius: 50%;
  margin-right: 0.6486486486486487rem;
  background-size: 100%;
}

.van-search__action {
  padding: 0 18px;
  font-size: 14px;
  line-height: 34px;
  margin: 0 10px;
  background-image: linear-gradient(-90deg, #f9da5b, #ffbd0a);
  color: #fff;
  border-radius: 16px;
}
.van-search__content {
  background: #f8f8f8;
}
</style>

<style>
.van-search--show-action {
  width: 100%;
  position: fixed;
  top: 50px;
  z-index: 99;
}
.van-index-bar__sidebar {
  background: #fff;
  box-shadow: 0 0 0.5405405405405406rem rgba(0, 0, 0, 0.1);
  border-radius: 0.2702702702702703rem;
  right: 5px !important;
}
.van-index-bar__index {
  padding: 0.13513513513513514rem 0.2972972972972973rem;
  font-size: 0.6486486486486487rem;
  color: #888;
}
.van-index-anchor {
  line-height: 46px !important;
}
.padding {
  padding: 0.8108108108108109rem;
  color: #323233;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cartsearch.vue